import styled from '@emotion/styled';
import {SlideTitle as SlideTitleUI} from 'ui';

export const SlideTitle = styled(SlideTitleUI)({
  marginBottom: 10,
});
